const SET_AGREEMENTS = (state, payload) => {
  state.agreements = payload;
};

const SET_CASE = (state, serviceCase) => {
  state.serviceCase = serviceCase;
};

export default {
  SET_AGREEMENTS,
  SET_CASE
}
